import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, FaArrowRight } from 'react-icons/fa';
import { MdEmail, MdLocationOn, MdPhone } from 'react-icons/md';
import { Link, useNavigate } from 'react-router';

const Footer = () => {
  const navigate = useNavigate();

  const handleHoroscopeClick = (link) => {
    navigate(link);
  }

  const Horoscope = [
    { title: "Horoscope 2024", link: "/horoscope" },
    { title: "Today's Horoscope", link: "/daily-horoscope" },
    { title: "Weekly Horoscope", link: "/weekly-horoscope" },
    { title: "Yearly Horoscope", link: "/yearly-horoscope" },
    { title: "Panchang", link: "/daily/panchang" },
  ];

  const importantLinks = [
    { title: "Today Panchang", link: "/daily/panchang" },
    { title: "Hora Panchang", link: "/hora/panchang" },
    { title: "Chaughadiya Panchang", link: "/chaughadiya/panchang" },
    { title: "Free Kundli", link: "/new-kundli" },
    { title: "Kundli Matching", link: "/kundlimatching" },
    { title: "Blogs", link: "/blog" },
  ];

  const handleImportantLinksClick = (link) => {
    navigate(link);
  };

  const OtherImportantLinks = [
    { title: "Natal chart", link: "/natalchart" },
    { title: "Love compatibility", link: "/love/compatibility" },
    { title: "Work compatibility", link: "/work/compatibility" },
    { title: "Chinese compatibility", link: "/chinese/compatibility" },
    { title: "Tarot Reading", link: "/tarot" },
    { title: "Blogs Admin", link: "/blog/admin-login" },
  ];

  const handleOtherImportantLinksClick = (link) => {
    navigate(link);
  };

  const corporateLinks = [
    { title: "Terms & Conditions", link: "/terms" },
    { title: "Privacy Policy", link: "/privacy" },
    { title: "Disclaimer", link: "/disclaimer" },
    { title: "About Us", link: "/about" },
  ];

  return (
    <footer className="bg-primary text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* About Section */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold mb-4 text-white">About AstroTellers</h3>
          <p className="text-gray-300 text-base leading-relaxed w-full">
            AstroTellers, your go-to platform for personalized astrology insights and guidance. Whether you're seeking Tarot readings, zodiac horoscopes, detailed Kundli predictions, or compatibility analysis, AstroTellers has you covered.
          </p>
        </div>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Horoscope Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 pb-2 border-b-2 border-white inline-block">Horoscope</h3>
            <ul className="space-y-3">
              {Horoscope.map((item) => (
                <li key={item.title}>
                  <button
                    onClick={() => handleHoroscopeClick(item.link)}
                    className="flex items-center text-white hover:text-gray-50 transition-colors"
                  >
                    <FaArrowRight className="mr-2 text-xs" />
                    {item.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Important Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 pb-2 border-b-2 border-white inline-block">Important Links</h3>
            <ul className="space-y-3">
              {importantLinks.map((item) => (
                <li key={item.title}>
                  <button
                    onClick={() => handleImportantLinksClick(item.link)}
                    className="flex items-center text-white hover:text-gray-50 transition-colors"
                  >
                    <FaArrowRight className="mr-2 text-xs" />
                    {item.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Other Important Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 pb-2 border-b-2 border-white inline-block">More Services</h3>
            <ul className="space-y-3">
              {OtherImportantLinks.map((item) => (
                <li key={item.title}>
                  <button
                    onClick={() => handleOtherImportantLinksClick(item.link)}
                    className="flex items-center text-white hover:text-gray-50 transition-colors"
                  >
                    <FaArrowRight className="mr-2 text-xs" />
                    {item.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 pb-2 border-b-2 border-white inline-block">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <MdEmail className="text-white mt-1 mr-3" />
                <Link className="text-white">infoastrorma@gmail.com</Link>
              </li>
              <li className="flex items-start">
                <MdPhone className="text-white mt-1 mr-3" />
                <span className="text-white">+91-9315970435</span>
              </li>
              {/* <li className="flex items-start">
                <MdLocationOn className="text-secondary mt-1 mr-3" />
                <span className="text-gray-300">Rankingeek Marketing Agency, 2nd Floor, 4/1, Shankar Market, Connaught Place, New Delhi - 110001</span>
              </li> */}
            </ul>

          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Social Media Icons */}
            <div className="flex space-x-6">
              <a href="#" className="text-white hover:text-gray-50 transition-colors">
                <FaFacebookF className="w-5 h-5" />
              </a>
              <a href="#" className="text-white hover:text-gray-50 transition-colors">
                <FaInstagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-white hover:text-gray-50 transition-colors">
                <FaLinkedinIn className="w-5 h-5" />
              </a>
              <a href="#" className="text-white hover:text-gray-50 transition-colors">
                <FaYoutube className="w-5 h-5" />
              </a>
            </div>

            {/* Copyright */}
            <div className="text-center md:text-right">
              <p className="text-gray-100 text-sm">
                © {new Date().getFullYear()} AstroTellers (Powered by RANKINGEEK MARKETING AGENCY). All Rights Reserved.
              </p>
            </div>
          </div>

          {/* Corporate Links */}
          {/* <div className="mt-6 flex flex-wrap justify-center gap-4">
            {corporateLinks.map((item) => (
              <Link
                key={item.title}
                
                className="text-gray-400 hover:text-secondary text-sm transition-colors"
              >
                {item.title}
              </Link>
            ))}
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
